import { useState, useEffect } from 'react'

export type GeoCenter = [number, number]

/**
 * Returns the user's approximate geographic position via the browser Geolocation API.
 * Resolves once on mount — returns null if denied or unavailable.
 */
export function useGeolocation(): GeoCenter | null {
  const [center, setCenter] = useState<GeoCenter | null>(null)

  useEffect(() => {
    if (!navigator.geolocation) return
    navigator.geolocation.getCurrentPosition(
      (pos) => setCenter([pos.coords.latitude, pos.coords.longitude]),
      () => { /* silent — component keeps its default center */ },
      { timeout: 6000, maximumAge: 5 * 60 * 1000 }
    )
  }, [])

  return center
}
